import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import http from '@lib/http-client'
import { SkillsStore } from './types'

export const useSkillsStore = create<SkillsStore>()(
  devtools(set => ({
    fetchSkills: async (userId: number) => {
      try {
        const endpoint = `/user/${userId}/skills`

        const response = await http.get(endpoint)

        if (!response || typeof response !== 'object') {
          return null
        }

        return response
      } catch (error) {
        console.error('Error fetching user skills:', error)
        return null
      }
    }
  }))
)
